import React from 'react';

import './RoleBox.scss';
import Icon from 'Core/Components/Icon';
import { isDefined } from 'Core/Utils/TypeUtils';
import { ListFieldItem } from 'RLX/Forms/ListField';

class RoleBox extends ListFieldItem {
  constructor (props) {
    super(props);
  }

  getClassName () {
    return 'RoleBox';
  }

  getItemTitle () {
    const { role } = this.props;
    const { company, position } = role;

    return `${company || 'Unknown company'}: ${position || 'Unknown position'}`;
  }

  shouldPromptBeforeDeleting (role = {}) {
    const { position, company, category, season, link, linkLabel, hidden, filled } = role;

    return (position && position.length)
      || (company && company.length)
      || (category && category.length)
      || (season && season.length)
      || (link && link.length)
      || (linkLabel && linkLabel.length)
      || hidden
      || filled;
  }

  getFields () {
    const { role } = this.props;
    const { propertyUpdaterFactory } = this;
    return [
      {
        label: 'Company',
        type: 'text',
        value: role.company,
        onChange: propertyUpdaterFactory('company', role),
        className: 'quarter'
      },
      {
        label: 'Position',
        type: 'text',
        value: role.position,
        onChange: propertyUpdaterFactory('position', role),
        className: 'quarter'
      },
      {
        label: 'category',
        type: 'text',
        value: role.category,
        onChange: propertyUpdaterFactory('category', role),
        className: 'quarter'
      },
      {
        label: 'Season',
        type: 'text',
        value: role.season,
        onChange: propertyUpdaterFactory('season', role),
        className: 'quarter'
      },
      {
        label: 'Link To URL',
        type: 'text',
        value: role.link,
        onChange: propertyUpdaterFactory('link', role),
        className: 'quarter'
      },
      {
        label: 'Link Label',
        type: 'text',
        value: role.linkLabel,
        onChange: propertyUpdaterFactory('linkLabel', role),
        className: 'quarter'
      },
      {
        label: 'Hidden',
        type: 'toggle',
        value: role.hidden,
        className: 'quarter',
        onChange: propertyUpdaterFactory('hidden', role)
      },
      {
        label: 'Has been filled',
        type: 'toggle',
        value: role.filled,
        className: 'quarter',
        onChange: propertyUpdaterFactory('filled', role)
      }
    ];
  }
};

export default RoleBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/RoleBox/RoleBox.jsx